const TEAM_MAP: Record<string, string> = {
  'liverpool fc': 'Liverpool',
  'liverpool': 'Liverpool',
  'newcastle united fc': 'Newcastle United',
  'newcastle united': 'Newcastle United',
  'man united': 'Manchester United',
  'manchester united fc': 'Manchester United',
  'manchester united': 'Manchester United',
  'tottenham hotspur': 'Tottenham Hotspur',
  'tottenham hotspur fc': 'Tottenham Hotspur',
  'tottenham fc': 'Tottenham Hotspur',
  'brentford fc': 'Brentford',
  'brentford': 'Brentford',
  'arsenal fc': 'Arsenal',
  'arsenal': 'Arsenal',
  'manchester city fc': 'Manchester City',
  'manchester city': 'Manchester City',
  'chelsea fc': 'Chelsea',
  'chelsea': 'Chelsea',
  'aston villa fc': 'Aston Villa',
  'aston villa': 'Aston Villa',
  'fulham fc': 'Fulham',
  'fulham': 'Fulham',
  'everton fc': 'Everton',
  'everton': 'Everton',
  'sunderland fc': 'Sunderland',
  'sunderland afc': 'Sunderland',
  'sunderland': 'Sunderland',
  'bournemouth fc': 'Bournemouth',
  'afc bournemouth': 'Bournemouth',
  'bournemouth': 'Bournemouth',
  'brighton and hove albion fc': 'Brighton & Hove Albion',
  'brighton & hove albion fc': 'Brighton & Hove Albion',
  'brighton & hove albion': 'Brighton & Hove Albion',
  'brighton and hove albion': 'Brighton & Hove Albion',
  'crystal palace fc': 'Crystal Palace',
  'crystal palace': 'Crystal Palace',
  'leeds united fc': 'Leeds United',
  'leeds united': 'Leeds United',
  'nottingham forest fc': 'Nottingham Forest',
  'nottingham forest': 'Nottingham Forest',
  'west ham united fc': 'West Ham United',
  'west ham fc': 'West Ham United',
  'west ham united': 'West Ham United',
  'burnley fc': 'Burnley',
  'burnley': 'Burnley',
  'wolverhampton wanderers fc': 'Wolverhampton Wanderers',
  'wolverhampton wanderers': 'Wolverhampton Wanderers',
  'atletico de madrid': 'Atletico Madrid',
  'atletico madrid': 'Atletico Madrid',
  'atlético madrid': 'Atletico Madrid',
  'paris saint-germain fc': 'Paris Saint-Germain',
  'paris saint-germain': 'Paris Saint-Germain',
  'paris saint germain fc': 'Paris Saint-Germain',
  'paris saint germain': 'Paris Saint-Germain',
  'psg': 'Paris Saint-Germain',
  'real madrid cf': 'Real Madrid',
  'real madrid': 'Real Madrid',
  'fc barcelona': 'Barcelona',
  'barcelona': 'Barcelona',
  'bayer 04 leverkusen': 'Bayer Leverkusen',
  'bayer leverkusen': 'Bayer Leverkusen',
  'fc inter milan': 'Inter Milan',
  'inter milan': 'Inter Milan',
  'sporting cp': 'Sporting Lisbon',
  'sporting portugal': 'Sporting Lisbon',
  'galatasaray sk': 'Galatasaray',
  'galatasaray': 'Galatasaray',
  'psv eindhoven': 'PSV Eindhoven',
  'borussia dortmund': 'Borussia Dortmund',
  'olympique de marseille': 'Marseille',
  'eintracht frankfurt': 'Eintracht Frankfurt',
  'port vale': 'Port Vale',
  'wigan': 'Wigan',
  'wigan athletic': 'Wigan',
  'hull city afc': 'Hull City',
  'hull city': 'Hull City',
  'queens park rangers': 'Queens Park Rangers',
  'middlesbrough fc': 'Middlesbrough',
  'middlesbrough': 'Middlesbrough',
  'charlton athletic fc': 'Charlton Athletic',
  'charlton athletic': 'Charlton Athletic',
  'portsmouth fc': 'Portsmouth',
  'portsmouth': 'Portsmouth',
  'southampton fc': 'Southampton',
  'southampton': 'Southampton',
  'leeds': 'Leeds United',
};

const EVENT_OVERRIDES: Record<string, string> = {
  'fa cup - final': 'FA Cup Final',
  'fa cup final 2026': 'FA Cup Final',
  'fa cup final': 'FA Cup Final',
  'carabao cup final 2026': 'Carabao Cup Final',
};

function standardizeTeam(raw: string): string {
  const trimmed = raw.trim();
  const key = trimmed.toLowerCase();

  if (TEAM_MAP[key]) return TEAM_MAP[key];

  const dashIdx = trimmed.indexOf(' - ');
  if (dashIdx !== -1) {
    const stripped = trimmed.slice(0, dashIdx).trim();
    if (TEAM_MAP[stripped.toLowerCase()]) return TEAM_MAP[stripped.toLowerCase()];
  }

  const parenIdx = trimmed.indexOf(' (');
  if (parenIdx !== -1) {
    const stripped = trimmed.slice(0, parenIdx).trim();
    if (TEAM_MAP[stripped.toLowerCase()]) return TEAM_MAP[stripped.toLowerCase()];
  }

  return trimmed;
}

export function standardizeEventName(name: string): string {
  if (!name) return name;

  const normalized = name.replace(/\bvs\.\s*/gi, 'vs ').trim();

  const overrideKey = normalized.toLowerCase();
  if (EVENT_OVERRIDES[overrideKey]) return EVENT_OVERRIDES[overrideKey];

  const match = normalized.match(/^(.+?)\s+vs\s+(.+)$/i);
  if (!match) return normalized;

  return `${standardizeTeam(match[1])} vs ${standardizeTeam(match[2])}`;
}
